import { FC, useContext } from 'react';
import { ResultPeriod } from '../ui';
import { CriteriaTime, ResultFlagName } from '@src/api';
import { resultOptions } from './ResultRefValueRule.conts';
import { useFormContext } from 'react-hook-form';
import { FormAutocompleteField } from '@components/FormFields';
import { RuleFactoryChildrenProps } from '../types';
import { Box } from '@mui/material';
import { DisableContext } from '@pages/Selection/components/DisableContext';
import { DisabledRuleItem } from '@components/DisabledRuleItem';

export const ResultRefValueRule: FC<RuleFactoryChildrenProps> = ({ prefix, children }) => {
  const { control, getValues, setValue } = useFormContext();

  const disabled = useContext(DisableContext);

  const scaleTypeName = `${prefix}.scaleType`;

  const [scaleType, scaleValue, loincItem, resultFlags] = getValues([
    scaleTypeName,
    `${prefix}.scaleValue`,
    `${prefix}.loincItem`,
    `${prefix}.resultFlags`,
  ]);

  const handleClickScaleType = (value: CriteriaTime) => {
    setValue(scaleTypeName, value);
  };

  return disabled ? (
    <DisabledRuleItem
      name="Result ref. values"
      value={`${scaleValue} ${CriteriaTime[scaleType].toLowerCase()}${scaleValue > 1 ? 's' : ''}`}
      valueName="In the last"
      descriptionName={loincItem?.name}
      description={resultFlags.map(flag => ResultFlagName[flag]).join(', ')}
    />
  ) : (
    <ResultPeriod scaleType={scaleType} handleClickScaleType={handleClickScaleType} prefix={prefix} disabled={disabled}>
      <>
        <Box maxWidth="380px" width="100%">
          <FormAutocompleteField
            control={control}
            name={`${prefix}.resultFlags`}
            options={resultOptions}
            placeholder="Select result"
            disabled={disabled}
            // maxWidth={380}
            multiple
            disableClearIcon
          />
        </Box>
        {children}
      </>
    </ResultPeriod>
  );
};
